export default __webpack_public_path__ + "media/images/home/language_2025_sm-a39aef16c4d1945280e3bfff2558b38d.jpg";